// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__1RfxT","clickable":"Table_clickable__1CC-3"};